import { SportListItem } from 'components/SportListItem/SportListItem';
import styles from './SportList.module.css';
import { Sport } from 'types/Sport';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { MobileMenu } from 'components/mobile/MobileMenu/MobileMenu';
import { MobileMenuItemProps } from 'components/mobile/MobileMenuItem/MobileMenuItem';
import { useTranslation } from 'react-i18next';
import { usePlayerLayout } from 'lib/playerLayout';
import { VipSports } from 'components/mobile/VipSports/VipSports';

interface Props {
  sports: Sport[];
  time?: string | null | undefined;
  /** Same sidebar as sports betting, counts from results/live window (get_leagues?results=1). */
  resultsMode?: boolean;
}

export const SportList = ({ sports, time, resultsMode = false }: Props) => {
  const { isMobile } = useBreakpoint();
  const { t } = useTranslation();
  const vip = usePlayerLayout() === 'vip';

  const sportsBettingMenu: MobileMenuItemProps[] = [
    // Three to a row: live betting in the middle of the first (owner).
    {
      iconKey: 'my-favorites',
      label: t('my_favorites_label'),
      destinationUrl: '/sports-betting/my-favorites',
    },
    {
      iconKey: 'live-betting',
      label: t('live_betting_label'),
      destinationUrl: '/live-betting',
    },
    {
      iconKey: 'highlights',
      label: t('highlights_label'),
      destinationUrl: '/sports-betting/highlights',
    },
    {
      iconKey: 'most-played-events',
      label: t('most_played_events_label'),
      destinationUrl: '/sports-betting/most-played-events',
    },
    {
      iconKey: 'last-minute-events',
      label: t('last_minute_events_label'),
      destinationUrl: '/sports-betting/last-minute-events',
    },
    {
      iconKey: 'today-events',
      label: t('today_label'),
      destinationUrl: '/sports-betting?time=today',
    },
  ];

  if (vip) {
    return (
      <VipSports
        sports={sports}
        time={time}
        resultsMode={resultsMode}
        shortcuts={resultsMode || time ? [] : sportsBettingMenu}
      />
    );
  }

  return (
    <>
      {isMobile && !time && <MobileMenu menuItems={sportsBettingMenu} />}
      <div className={styles.wrapper}>
        {(!sports || sports.length === 0) && (
          <p className={styles.emptyMessage}>{t('no_events_in_period')}</p>
        )}
        {sports &&
          sports.length > 0 &&
          sports.map((s) => (
            <SportListItem
              sport={s}
              key={s.id}
              time={time}
              resultsMode={resultsMode}
            />
          ))}
      </div>
    </>
  );
};
